import '@styles/react-components/shipment-tracking.scss';
import React from 'react';
import ReactDOM from "react-dom/client";
import ShipmentTracking from '@components/shipment-tracking/ShipmentTracking';

const render = () => {
  var shipmentTrackingWrappers = document.getElementsByClassName("shipment-tracking");

  for (var i = 0; i < shipmentTrackingWrappers.length; i++) {
    const root = ReactDOM.createRoot(shipmentTrackingWrappers[i]);
    root.render(<ShipmentTracking {...shipmentTrackingWrappers[i].dataset}/>)
  }
}

render();